// used to manage the display of tabs as they wrap on channel-lineup pages (e.g. /cox/channel-lineup/starter)

import { debounce } from './_utilities';

const loadCustomTabs = () => {
    $(document).ready(() => {
        const tabsContainer = document.querySelectorAll('.tabs__container');

        if (tabsContainer.length > 0) {
            // check for existence of tabs__container

            const tabsPanelsBorderTop = document.querySelectorAll(
                '.tabs__panels-border-top'
            );

            // check to see if tabs are wrapping, add top padding to tabs__panels and
            // make a bottom border div appear beneath them
            const adjustTabsContainer = () => {
                if (tabsPanelsBorderTop.length > 0) {
                    // check for existence of the tabs__panels-border-top div
                    const offSetTopFirst = $('.tabs li:first-child').offset()
                        .top; // offset.top of first tab
                    const offSetTopLast = $('.tabs li:last-child').offset().top; // offset.top of last tab in set

                    if (offSetTopLast > offSetTopFirst) {
                        // tab has wrapped
                        if (window.Foundation.MediaQuery.atLeast('medium')) {
                            // (only one tab shown on small)

                            // this class adds top padding to the tabs__panel to provide space for the wrapped tab(s).
                            // it also displays and adjusts the tabs__panels-border-top which acts as a bottom border
                            // for the wrapped tabs
                            $('.tabs__panels').addClass('tabs__panels--higher'); // add it
                        }
                    } else {
                        $('.tabs__panels').removeClass('tabs__panels--higher'); // remove it
                    }
                }
            };

            adjustTabsContainer();

            $(window).resize(() => {
                debounce(adjustTabsContainer());
            });
        }
    });
};

// Module startup
const init = () => {
    loadCustomTabs();
};

export { init };
